import type {DiffLine} from '../../types'
import {useMemo} from 'react'
import {SimpleSplitDiffRow} from './SimpleSplitDiffRow'

function groupDiffLines(lines: DiffLine[]): {
  leftLines: Array<DiffLine | undefined>
  rightLines: Array<DiffLine | undefined>
} {
  const leftLines: Array<DiffLine | undefined> = []
  const rightLines: Array<DiffLine | undefined> = []

  // Keep list of lines even, filling in blanks as needed
  const fillBlanks = () => {
    while (leftLines.length < rightLines.length) {
      leftLines.push(undefined)
    }

    while (rightLines.length < leftLines.length) {
      rightLines.push(undefined)
    }
  }

  for (const line of lines) {
    switch (line.type) {
      case 'ADDITION':
        rightLines.push(line)
        break
      case 'DELETION':
        leftLines.push(line)
        break
      case 'CONTEXT':
      case 'INJECTED_CONTEXT':
        fillBlanks()
        leftLines.push(line)
        rightLines.push(line)
        break
      case 'HUNK':
        fillBlanks()
        leftLines.push(line)
        rightLines.push(line)
    }
  }
  fillBlanks()

  return {leftLines, rightLines}
}

function useGroupedLines(diffLines: DiffLine[]) {
  const {leftLines, rightLines} = useMemo(() => groupDiffLines(diffLines), [diffLines])

  return {leftLines, rightLines}
}

export function SimpleSplitDiffLines({diffLines, filePath}: {diffLines: DiffLine[]; filePath: string}) {
  const {leftLines, rightLines} = useGroupedLines(diffLines)
  return leftLines.map((_, index) => {
    const leftDiffLine = leftLines[index]
    const rightDiffLine = rightLines[index]
    const key = `${!leftDiffLine ? `empty-left-diff-${index}` : leftDiffLine.blobLineNumber}-${
      !rightDiffLine ? `empty-right-diff-${index}` : rightDiffLine.blobLineNumber
    }`

    return (
      <SimpleSplitDiffRow leftDiffLine={leftDiffLine} rightDiffLine={rightDiffLine} filePath={filePath} key={key} />
    )
  })
}

try{ SimpleSplitDiffLines.displayName ||= 'SimpleSplitDiffLines' } catch {}